export enum CarAcquisitionType {
  PURCHASED_NEW = 'PURCHASED_NEW',
  PURCHASED_USED = 'PURCHASED_USED',
  LEASED = 'LEASED',
}
